var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanguages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 25,
    viewBox: "0 0 250 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4652",
    "data-name": "Rectangle 4652",
    width: 25,
    height: 25,
    transform: "translate(182 127)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4824",
    "data-name": "Group 4824",
    transform: "translate(-182 -162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4654",
    "data-name": "Rectangle 4654",
    transform: "translate(224 162)",
    fill: "none",
    stroke: "#cecdcd",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 25,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 66.5,
    height: 24.5,
    rx: 9.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_163",
    "data-name": "Mask Group 163",
    transform: "translate(0 35)",
    clipPath: "url(#clip-path)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "English",
    transform: "translate(234 179)",
    fill: "#cecdcd",
    fontSize: 14,
    fontFamily: "Quicksand-Light, Quicksand",
    fontWeight: 300,
    letterSpacing: "0.025em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "English")), /*#__PURE__*/React.createElement("text", {
    id: "T\\xFCrk\\xE7e",
    transform: "translate(315 180)",
    fill: "#8e8e8e",
    fontSize: 14,
    fontFamily: "Quicksand-Light, Quicksand",
    fontWeight: 300,
    letterSpacing: "0.025em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T\xFCrk\xE7e")), /*#__PURE__*/React.createElement("path", {
    id: "Path_19061",
    "data-name": "Path 19061",
    d: "M2.68-7.976a.387.387,0,0,1-.441-.435q0-.422.441-.422a.375.375,0,0,1,.427.422A.381.381,0,0,1,2.68-7.976Zm1.392,0a.387.387,0,0,1-.441-.435q0-.422.441-.422a.375.375,0,0,1,.427.422A.381.381,0,0,1,4.073-7.976Zm2.784,6.89h.593v.553H6.76A2.038,2.038,0,0,1,4.679-1.758,2.384,2.384,0,0,1,2.8-.928,2.186,2.186,0,0,1,.985-1.771a2.812,2.812,0,0,1-.565-1.8,2.749,2.749,0,0,1,.731-2A2.22,2.22,0,0,1,2.8-6.237a2.3,2.3,0,0,1,1.7.646v-.869l.648-.329v4.018A1.5,1.5,0,0,0,6.857-1.086ZM4.5-4.841a2.086,2.086,0,0,0-1.7-.843A1.548,1.548,0,0,0,1.55-5.1a2.317,2.317,0,0,0-.482,1.522,2.306,2.306,0,0,0,.476,1.522A1.557,1.557,0,0,0,2.8-1.481a2.14,2.14,0,0,0,1.723-.869Q4.5-2.614,4.5-2.759Zm6.781,3.754h.593v.553h-.689a2.054,2.054,0,0,1-1.93-.962,2.087,2.087,0,0,1-1.943.962H6.622v-.553h.593A1.5,1.5,0,0,0,8.924-2.773v-3l.648-.329v3.333A1.5,1.5,0,0,0,11.281-1.086ZM8.29.916a.381.381,0,0,1,.427.435.375.375,0,0,1-.427.422q-.441,0-.441-.422A.387.387,0,0,1,8.29.916Zm1.392,0a.381.381,0,0,1,.427.435.375.375,0,0,1-.427.422q-.441,0-.441-.422A.387.387,0,0,1,9.682.916ZM11.047-.533v-.553h2.426v.553Zm1.206,0v-.553h.593a1.5,1.5,0,0,0,1.709-1.686v-3l.648-.329v3.346a2.179,2.179,0,0,1-.648,1.673,2.3,2.3,0,0,1-1.613.553ZM14.5,1.772a.387.387,0,0,1-.441-.435q0-.422.441-.422a.375.375,0,0,1,.427.422A.381.381,0,0,1,14.5,1.772Zm7.374-2.859h.593v.553h-.689a2.3,2.3,0,0,1-1.613-.553,3.213,3.213,0,0,1-.758,2.253,2.473,2.473,0,0,1-1.943.8,3.443,3.443,0,0,1-1.5-.343V1.074a3.2,3.2,0,0,0,1.433.356,1.9,1.9,0,0,0,1.7-.843,2.993,2.993,0,0,0,.427-1.66v-4.7l.648-.329v3.333A1.5,1.5,0,0,0,21.873-1.086Zm5.334-.224.069.026a1.873,1.873,0,0,0,.841.2h3.845v.553H28.117a2.48,2.48,0,0,1-1.323-.382,2.48,2.48,0,0,1-1.323.382H21.639v-.553h3.832a2.066,2.066,0,0,0,.841-.2A7.491,7.491,0,0,1,25-2.272a11.182,11.182,0,0,1-1.53-1.686v-.369a4.142,4.142,0,0,1,3.322-1.91,4.171,4.171,0,0,1,3.336,1.923v.356A12.189,12.189,0,0,1,27.207-1.31Zm-.413-.277a11.619,11.619,0,0,0,1.633-1.278,6.825,6.825,0,0,0,1.137-1.291,3.533,3.533,0,0,0-2.812-1.528,3.513,3.513,0,0,0-2.715,1.528A9.308,9.308,0,0,0,26.794-1.587ZM31.136-.533v-.553h2.426v.553Zm1.206,0v-.553h.593a1.5,1.5,0,0,0,1.709-1.686V-8.7l.648-.329v6.271a2.179,2.179,0,0,1-.648,1.673,2.3,2.3,0,0,1-1.613.553Zm5.431,0V-8.7l.648-.329v8.5Z",
    transform: "translate(393.58 178.029)",
    fill: "#8e8e8e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguages);
export default __webpack_public_path__ + "static/media/languages.31bec8ff1d7bb19b1dfb6f96109eda29.svg";
export { ForwardRef as ReactComponent };